import { cssWhen } from '../../../../shared/utils/themeUtils';
import classes from './OrderConfirmRow.module.scss';

export interface OrderConfirmRowProps {
  label: string;
  value?: string;
  isDark?: boolean;
  isDivider?: boolean;
  isUppercase?: boolean;
  testIdBase?: string;
}

export const OrderConfirmRow = ({ label, value, isDark, isDivider, isUppercase, testIdBase }: OrderConfirmRowProps) => {
  return (
    <div
      data-testid={testIdBase ? `${testIdBase}-row` : undefined}
      className={cssWhen(
        classes.orderConfirmRow,
        [isDark, classes.orderConfirmRowIsDark],
        [isDivider, classes.orderConfirmRowIsDivider],
        [isUppercase, classes.orderConfirmRowIsUppercase],
      )}
    >
      <span data-testid={testIdBase ? `${testIdBase}-label` : undefined}>{label}</span>
      <span data-testid={testIdBase ? `${testIdBase}-value` : undefined}>{value}</span>
    </div>
  );
};
